import firebase from 'firebase'

var config = {
  apiKey: "AIzaSyBZcDM9kzAA6TfY66h8ppRboWW2cFkQ888",
  authDomain: "currency-5af17.firebaseapp.com",
  databaseURL: "https://currency-5af17.firebaseio.com",
  projectId: "currency-5af17",
  storageBucket: "currency-5af17.appspot.com",
  messagingSenderId: "407851957053"
};
firebase.initializeApp(config);

export default {
  db: firebase.app().database().ref('data'),
  auth: firebase.app().auth()
}


// WEBPACK FOOTER //
// ./src/firebase.js